import { render, staticRenderFns } from "./UDCopyControls.vue?vue&type=template&id=97bb09b4&scoped=true&"
import script from "./UDCopyControls.vue?vue&type=script&lang=js&"
export * from "./UDCopyControls.vue?vue&type=script&lang=js&"
import style0 from "./UDCopyControls.vue?vue&type=style&index=0&id=97bb09b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bb09b4",
  null
  
)

export default component.exports